import * as types from "../loanPlanActionTypes";

const initialState = {
  all: [],
  active: [],
  pending: [],
  currentLoanPlan: {},
  repayments: [],
  upcomingPayments: []
}

export default function loans(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_LOAN_PLANS:
      const active = action.payload.filter((loan_plan) => { return !!loan_plan.is_percentage_completed === true });
      const pending = action.payload.filter((loan_plan) => { return !!loan_plan.is_percentage_completed === false });

      return {
        ...state,
        all: action.payload,
        active: active,
        pending: pending,
      };
    case types.RECEIVE_LOAN_PLAN:
      return {
        ...state,
        currentLoanPlan: action.payload,
      };
    case types.RECEIVE_REPAYMENTS:
      return {
        ...state,
        repayments: action.payload,
      };
    case types.RECEIVE_UPCOMING_PAYMENTS:
      return {
        ...state,
        upcomingPayments: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/reducers/loans.js